import React, { useEffect, useState } from "react";
import {
  DialogActions,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import { Search, Today, CalendarMonth } from "@mui/icons-material";
import DialogLayout from "../../../../partials/content/DialogLayout";
import NumberFormat from "react-number-format";
import { getProfitLossReport } from "../../../../services/finance/financeReportService";
import { Table } from "react-bootstrap";
import SearchFiscalYear from "../../setup/finance/searchFiscalYear";
import SearchFiscalPeriod from "../../setup/finance/searchFiscalPeriod";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import { DateTime } from "luxon";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
function ProfitLossStatement(props) {
  const {
    companyProfile,
    currentFiscalYear,
    currentFiscalPeriod,
    reload,
  } = useGlobalData();
  const [searchByFiscalYear, setSearchByFiscalYear] = useState(false);
  const [openSearchFiscalYear, setOpenSearchFiscalYear] = useState(false);
  const [openSearchFiscalPeriod, setOpenSearchFiscalPeriod] = useState(false);
  const [fiscalYear, setFiscalYear] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );
  const [fiscalPeriod, setFiscalPeriod] = useState(
    currentFiscalPeriod.ID > 0
      ? currentFiscalPeriod
      : {
          ID: 0,
          fiscalYearID: 0,
          year: DateTime.now().year,
          month: DateTime.now().month,
          monthName: DateTime.now().toLocaleString({
            month: "long",
          }),
          statusID: 0,
        }
  );
  const [totalSales, setTotalSales] = useState(0);
  const [totalCogs, setTotalCogs] = useState(0);
  const [grossProfit, setGrossProfit] = useState(0);
  const [totalExpense, setTotalExpense] = useState(0);
  const [totalOpExpense, setTotalOpExpense] = useState(0);
  const [totalOpNetIncome, setTotalOpNetIncome] = useState(0);
  const [netProfit, setNetProfit] = useState(0);
  const [profitLoss, setProfitLoss] = useState([]);

  async function getProfitLossReportData(
    fiscalYearID = 0,
    fiscalYear = DateTime.now().year,
    fiscalPeriod = DateTime.now().month
  ) {
    const response = await getProfitLossReport(
      fiscalYearID,
      fiscalYear,
      fiscalPeriod
    );
    const { data } = response.data;
    const {
      profitLoss,
      grossProfit,
      totalSales,
      totalCogs,
      netProfit,
      totalOpExpense,
      totalExpense,
      totalOpNetIncome,
    } = data;
    setProfitLoss(profitLoss);
    setTotalSales(totalSales);
    setTotalCogs(totalCogs);
    setGrossProfit(grossProfit);
    setTotalExpense(totalExpense);
    setNetProfit(netProfit);
    setTotalOpExpense(totalOpExpense);
    setTotalOpNetIncome(totalOpNetIncome);
  }

  useEffect(() => {
    getProfitLossReportData(0, fiscalPeriod.year, fiscalPeriod.month);
  }, [reload]);

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <div className="row justify-content-center">
            <div className="col-sm-10 col-md-6 col-lg-4">
              {searchByFiscalYear === true ? (
                <TextField
                  id="fiscalYear"
                  label="Fiscal Year"
                  value={
                    fiscalYear.startMonthName +
                    " " +
                    fiscalYear.year +
                    " - " +
                    fiscalYear.endMonthName +
                    " " +
                    fiscalYear.yearTo
                  }
                  style={{ width: "100%" }}
                  variant="outlined"
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalYear(true);
                              /*
                              if (currentFiscalYear.ID > 0) {
                                setFiscalYear(currentFiscalYear);
                                getProfitLossReportData(
                                  currentFiscalYear.ID,
                                  0,
                                  0
                                );
                              }
                              */
                            }}
                            edge="end"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                        <BootstrapTooltip title="Search By Fiscal Period">
                          <IconButton
                            type="button"
                            aria-label="SearchBy"
                            onClick={() => {
                              setSearchByFiscalYear(false);
                              /*
                              if (currentFiscalPeriod.ID > 0) {
                                setFiscalPeriod(currentFiscalPeriod);
                                getProfitLossReportData(
                                  0,
                                  currentFiscalPeriod.year,
                                  currentFiscalPeriod.month
                                );
                              }
                              */
                            }}
                            edge="end"
                          >
                            <Today />
                          </IconButton>
                        </BootstrapTooltip>
                      </InputAdornment>
                    ),
                    readOnly: true,
                  }}
                />
              ) : (
                <TextField
                  id="fiscalPeriod"
                  label="Fiscal Period"
                  value={fiscalPeriod.monthName + " " + fiscalPeriod.year}
                  style={{ width: "100%" }}
                  variant="outlined"
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <BootstrapTooltip title="Search">
                          <IconButton
                            type="button"
                            aria-label="Search"
                            onClick={() => {
                              setOpenSearchFiscalPeriod(true);
                            }}
                            edge="end"
                          >
                            <Search />
                          </IconButton>
                        </BootstrapTooltip>
                        <BootstrapTooltip title="Search By Fiscal Year">
                          <IconButton
                            type="button"
                            aria-label="SearchBy"
                            onClick={() => {
                              setSearchByFiscalYear(true);
                              if (currentFiscalYear.ID > 0) {
                                setFiscalYear(currentFiscalYear);
                                /*getProfitLossReportData(
                                  currentFiscalPeriod.year,
                                  currentFiscalPeriod.month
                                );*/
                              }
                            }}
                            edge="end"
                          >
                            <CalendarMonth />
                          </IconButton>
                        </BootstrapTooltip>
                      </InputAdornment>
                    ),
                    readOnly: true,
                  }}
                />
              )}
            </div>
            <div className="col-sm-2 col-md-2 col-lg-2">
              <button
                className="btn btn-primary"
                onClick={() => {
                  if (fiscalYear.ID > 0) {
                    getProfitLossReportData(fiscalYear.ID, 0, 0);
                  } else if (fiscalPeriod.year > 0 && fiscalPeriod.month > 0) {
                    getProfitLossReportData(
                      0,
                      fiscalPeriod.year,
                      fiscalPeriod.month
                    );
                  }
                }}
              >
                Load
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-sm-12 col-md-10 col-lg-10">
          <div className="card">
            <Table striped borderless size="sm" responsive="xl">
              <tbody>
                <tr>
                  <td className="bg-secondary px-2" colSpan="2">
                    <Typography className="kt-font-bolder">Revenue</Typography>
                  </td>
                </tr>
                {profitLoss && profitLoss.length > 0
                  ? profitLoss.map((item, index) => {
                      if (item.categoryID !== 1) {
                        return null;
                      }
                      return (
                        <tr key={index}>
                          <td className="px-5">
                            <Typography className="kt-font-bold text-muted">
                              {item.accountName}
                            </Typography>
                          </td>
                          <td className="px-2">
                            <Typography
                              component="div"
                              className="kt-font-bold text-muted"
                            >
                              <NumberFormat
                                value={item.amount}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">{value}</div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                      );
                    })
                  : null}
                <tr>
                  <td className="px-5">
                    <Typography className="kt-font-bolder">
                      Total Gross Revenue
                    </Typography>
                  </td>
                  <td className="px-2">
                    <Typography component="div" className="kt-font-bolder">
                      <NumberFormat
                        value={totalSales}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">{value}</div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="bg-secondary px-2" colSpan="2">
                    <Typography className="kt-font-bolder">
                      Cost of Goods Sold
                    </Typography>
                  </td>
                </tr>
                {profitLoss && profitLoss.length > 0
                  ? profitLoss.map((item, index) => {
                      if (item.categoryID !== 2) {
                        return null;
                      }
                      return (
                        <tr key={index}>
                          <td className="px-5">
                            <Typography className="kt-font-bold text-muted">
                              {item.accountName}
                            </Typography>
                          </td>
                          <td className="px-2">
                            <Typography
                              component="div"
                              className="kt-font-bold text-muted"
                            >
                              <NumberFormat
                                value={item.amount}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">{value}</div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                      );
                    })
                  : null}
                <tr>
                  <td className="px-5">
                    <Typography className="kt-font-bolder">
                      Total Cost of Goods Sold
                    </Typography>
                  </td>
                  <td className="px-2">
                    <Typography component="div" className="kt-font-bolder">
                      <NumberFormat
                        value={totalCogs}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">{value}</div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${
                      grossProfit > 0
                        ? "bg-success"
                        : grossProfit < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography className="kt-font-bolder text-white">
                      GROSS PROFIT
                    </Typography>
                  </td>
                  <td
                    className={`${
                      grossProfit > 0
                        ? "bg-success"
                        : grossProfit < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography
                      component="div"
                      className="kt-font-bolder text-white"
                    >
                      <NumberFormat
                        value={grossProfit}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">
                            {companyProfile.currency.currencyCode} {value}
                          </div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="bg-secondary px-2" colSpan="2">
                    <Typography className="kt-font-bolder">
                      Operating Expenses
                    </Typography>
                  </td>
                </tr>
                {profitLoss && profitLoss.length > 0
                  ? profitLoss.map((item, index) => {
                      if (item.categoryID !== 3) {
                        return null;
                      }
                      return (
                        <tr key={index}>
                          <td className="px-5">
                            <Typography className="kt-font-bold text-muted">
                              {item.accountName}
                            </Typography>
                          </td>
                          <td className="px-2">
                            <Typography
                              component="div"
                              className="kt-font-bold text-muted"
                            >
                              <NumberFormat
                                value={item.amount}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">{value}</div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                      );
                    })
                  : null}
                <tr>
                  <td className="px-5">
                    <Typography className="kt-font-bolder">
                      Total Operating Expenses
                    </Typography>
                  </td>
                  <td className="px-2">
                    <Typography component="div" className="kt-font-bolder">
                      <NumberFormat
                        value={totalOpExpense}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">{value}</div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${
                      grossProfit > 0
                        ? "bg-success"
                        : grossProfit < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography className="kt-font-bolder text-white">
                      OPERATING NET INCOME
                    </Typography>
                  </td>
                  <td
                    className={`${
                      grossProfit > 0
                        ? "bg-success"
                        : grossProfit < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography
                      component="div"
                      className="kt-font-bolder text-white"
                    >
                      <NumberFormat
                        value={totalOpNetIncome}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">
                            {companyProfile.currency.currencyCode} {value}
                          </div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td className="bg-secondary px-2" colSpan="2">
                    <Typography className="kt-font-bolder">Expenses</Typography>
                  </td>
                </tr>
                {profitLoss && profitLoss.length > 0
                  ? profitLoss.map((item, index) => {
                      if (item.categoryID !== 4) {
                        return null;
                      }
                      return (
                        <tr key={index}>
                          <td className="px-5">
                            <Typography className="kt-font-bold text-muted">
                              {item.accountName}
                            </Typography>
                          </td>
                          <td className="px-2">
                            <Typography
                              component="div"
                              className="kt-font-bold text-muted"
                            >
                              <NumberFormat
                                value={item.amount}
                                displayType={"text"}
                                thousandSeparator={true}
                                decimalScale={2}
                                renderText={(value) => (
                                  <div className="float-right">{value}</div>
                                )}
                              />
                            </Typography>
                          </td>
                        </tr>
                      );
                    })
                  : null}
                <tr>
                  <td className="px-5">
                    <Typography className="kt-font-bolder">
                      Total Expenses
                    </Typography>
                  </td>
                  <td className="px-2">
                    <Typography component="div" className="kt-font-bolder">
                      <NumberFormat
                        value={totalExpense}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">{value}</div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
                <tr>
                  <td
                    className={`${
                      netProfit > 0
                        ? "bg-success"
                        : netProfit < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography className="kt-font-bolder text-white">
                      NET PROFIT
                    </Typography>
                  </td>
                  <td
                    className={`${
                      netProfit > 0
                        ? "bg-success"
                        : netProfit < 0
                        ? "bg-danger"
                        : "bg-info"
                    } px-2`}
                  >
                    <Typography
                      component="div"
                      className="kt-font-bolder text-white"
                    >
                      <NumberFormat
                        value={netProfit}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={2}
                        renderText={(value) => (
                          <div className="float-right">
                            {companyProfile.currency.currencyCode} {value}
                          </div>
                        )}
                      />
                    </Typography>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      </div>
      <DialogLayout
        open={openSearchFiscalYear}
        title="Search Fiscal Year"
        onCloseDialog={() => {
          setOpenSearchFiscalYear(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalYear
          onSelectFiscalYear={(fiscalYear) => {
            setFiscalYear({
              ID: fiscalYear.ID,
              year: fiscalYear.year,
              yearTo: fiscalYear.yearTo,
              startMonth: fiscalYear.startMonth,
              startMonthName: fiscalYear.startMonthName,
              endMonth: fiscalYear.endMonth,
              endMonthName: fiscalYear.endMonthName,
            });
            setFiscalPeriod({
              ID: 0,
              fiscalYearID: 0,
              year: 0,
              month: 0,
              monthName: "",
              statusID: 0,
            });
            setOpenSearchFiscalYear(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalYear(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchFiscalPeriod}
        title="Search Fiscal Period"
        onCloseDialog={() => {
          setOpenSearchFiscalPeriod(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalPeriod
          onSelectFiscalPeriod={(fiscalPeriod) => {
            setFiscalPeriod({
              ID: fiscalPeriod.ID,
              fiscalYearID: fiscalPeriod.fiscalYearID,
              year: fiscalPeriod.year,
              month: fiscalPeriod.month,
              monthName: fiscalPeriod.monthName,
              statusID: fiscalPeriod.statusID,
            });
            setFiscalYear({
              ID: 0,
              year: 0,
              yearTo: 0,
              startMonth: 0,
              startMonthName: "",
              endMonth: 0,
              endMonthName: "",
            });
            setOpenSearchFiscalPeriod(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalPeriod(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default ProfitLossStatement;
